import React from "react";
import "./index.css";
import "@piiqtechnologies/ui-lib/lib/index.css";
import { ThemeProvider } from "@piiqtechnologies/ui-components";
import * as Sentry from "@sentry/react";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router-dom";
import GlobalStyles from "@mui/material/GlobalStyles";
import CssBaseline from "@mui/material/CssBaseline";
import { AnalyticsProvider, ErrorProvider, LoaderProvider, NotificationProvider } from "@piiqtechnologies/ui-lib";
import { HelmetProvider } from "react-helmet-async";
import messages from "./lang/en.json";
import AppRoutes from "./Routes";
import theme from "./theme";
import AuthContextProvider from "@stores/AuthContext";
import { ERROR_CODES } from "@components/common/error";
import { Error } from "./pages/error";
import { analytics } from "./analytics-setup";
const initLocale = "en";
const App = () => {
    return (React.createElement(HelmetProvider, null,
        React.createElement(BrowserRouter, null,
            React.createElement(ErrorProvider, null,
                React.createElement(LoaderProvider, null,
                    React.createElement(AnalyticsProvider, { instance: analytics },
                        React.createElement(NotificationProvider, null,
                            React.createElement(ThemeProvider, { theme: theme },
                                React.createElement(CssBaseline, null),
                                React.createElement(GlobalStyles, { styles: {
                                        "*::-webkit-scrollbar": {
                                            backgroundColor: "transparent",
                                            width: 6,
                                        },
                                        "*::-webkit-scrollbar-track": {
                                            boxShadow: "none !important",
                                            backgroundColor: "transparent",
                                        },
                                        "*::-webkit-scrollbar-thumb": {
                                            backgroundColor: theme.palette.grey[200],
                                            borderRadius: theme.spacing(10),
                                        },
                                        body: {
                                            fontFamily: theme.typography.fontFamily,
                                        },
                                    } }),
                                React.createElement(IntlProvider, { messages: messages, locale: initLocale },
                                    React.createElement(AuthContextProvider, null,
                                        React.createElement(AppRoutes, null)))))))))));
};
export default Sentry.withErrorBoundary(App, {
    fallback: (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(IntlProvider, { messages: messages, locale: initLocale },
            React.createElement(Error, { errorCode: ERROR_CODES.INTERNAL_ERROR })))),
});
